import flow from 'lodash/flow';
import { withAnalyticsEvents, type CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import { withFireUiAnalytics } from '@atlassian/jira-analytics-web-react/src';
import { connect } from '@atlassian/jira-react-redux';
import type { AccountId } from '@atlassian/jira-shared-types';
import { fetchAppLink } from '../../state/actions/fetch-applink';
import { fetchArticle } from '../../state/actions/fetch-article';
import { getAppLinkState } from '../../state/selectors/applink';
import { getArticle } from '../../state/selectors/articles';
import { getActivationId, getProjectId, getProjectKey } from '../../state/selectors/base';
import type { State } from '../../state/types';

import KnowledgeHubArticle from './view';

type ConnectedKnowledgeHubArticleProps = {
	id: string;
	createAnalyticsEvent: CreateUIAnalyticsEvent;
	accountId: AccountId | null;
	spaceKey: string | undefined;
};

export default flow([
	withFireUiAnalytics({
		onEditClicked: 'editInConfluence',
		onCopyClicked: 'copyShareUrl',
	}),
	withAnalyticsEvents(),
	connect(
		(state: State, ownProps: ConnectedKnowledgeHubArticleProps) => ({
			article: getArticle(state, ownProps.id),
			projectKey: getProjectKey(state),
			projectId: getProjectId(state),
			appLinkState: getAppLinkState(state),
			activationId: getActivationId(state),
		}),
		{
			onFetchArticle: fetchArticle,
			onFetchAppLink: fetchAppLink,
		},
	),
])(KnowledgeHubArticle);
